import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_COMMODITY_ORIGIN_PRODUCTION_PLACES_KEY } from '@/keys';
import type {
  ProductionPlace,
  ProductionPlaceCoordinates,
} from '@/types/core/production-declaration/production-place';

type CreateProductionPlaceVariables = {
  productionDeclarationId: string;
  materialId: string;
  commodityOriginId: string;
  coordinates: ProductionPlaceCoordinates;
  countryId: number;
  description: string;
  forestTypeId: number;
  productionTimeRange: string;
  token?: string;
};

async function createProductionPlace({
  productionDeclarationId,
  materialId,
  commodityOriginId,
  token,
  ...payload
}: CreateProductionPlaceVariables): Promise<ProductionPlace> {
  const response = await api.post<ProductionPlace>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins/${commodityOriginId}/production-places`,
    payload,
    {
      params: token ? { token } : undefined,
    },
  );

  return response.data;
}

export function useCreateProductionPlace(): UseMutationResult<
  ProductionPlace,
  Error,
  CreateProductionPlaceVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createProductionPlace,
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          ...GET_PRODUCTION_DECLARATION_COMMODITY_ORIGIN_PRODUCTION_PLACES_KEY,
          variables.productionDeclarationId,
          variables.materialId,
          variables.commodityOriginId,
          variables.token ?? '',
        ],
      });
    },
  });
}
